import contract from '@mailobj-browser/front/js/contracts/contract.js'
import manager from '@mailobj-browser/front/js/contracts/manager.js'
import dump from './dump/dump.js'
import './mock.js'
import './importmap_cookie.js'

queueMicrotask(async () => {
  await manager.ready()
  console.log('%cReady', 'color: #bada55')
})

export default contract({
  dump
})
